import * as THREE from "three";

export class LightGenerator {
    scene = new THREE.Scene()

    constructor(scene) {
        this.scene = scene
    }

    createPointLight(color, intensity, distance, decay, x, y, z) {
        let sakuraLight = new THREE.PointLight(color, intensity, distance, decay);
        sakuraLight.position.set(x, y, z);
        this.scene.add(sakuraLight)
        return sakuraLight;
    }

    createSakuraSpotlight() {
        let spotLight = new THREE.SpotLight(0xff00ff, 8, 5, Math.PI / 3, 1, 1);
        spotLight.position.set(0, 0.1, 0);
        spotLight.visible = false;
        spotLight.castShadow = false;
        spotLight.shadow.mapSize.width = 1024;
        spotLight.shadow.mapSize.height = 1024;
        spotLight.shadow.camera.near = 0.5;
        spotLight.shadow.camera.far = 2;
        spotLight.shadow.normalBias = 0.02;
        this.scene.add(spotLight.target);

        const helper2 = new THREE.CameraHelper(spotLight.shadow.camera);
        return spotLight;
    }

    createSunlight() {
        let shadowMapSize = 13;
        const sunLight = new THREE.DirectionalLight(0xcce0ff, 0.9, 100);
        sunLight.position.set(8, 18, 10);
        sunLight.color.setHSL(0.6, 0.08, 0.88);
        sunLight.visible = true;
        sunLight.castShadow = true;
        sunLight.shadow.mapSize.width = 2048;
        sunLight.shadow.mapSize.height = 2048;
        sunLight.shadow.camera.near = 0.5;
        sunLight.shadow.camera.far = shadowMapSize * 2;
        sunLight.shadow.camera.top = shadowMapSize;
        sunLight.shadow.camera.bottom = -shadowMapSize;
        sunLight.shadow.camera.left = -shadowMapSize;
        sunLight.shadow.camera.right = shadowMapSize;
        sunLight.shadow.normalBias = 0.02;
        this.scene.add(sunLight);
        this.scene.add(sunLight.target);
        const helper = new THREE.CameraHelper(sunLight.shadow.camera);

        return sunLight;
    }

    createHemiLight() {
        const hemiLight = new THREE.HemisphereLight(0x1a1a40, 0x0a0a15, 0.55);
        hemiLight.color.setHSL(0.65, 0.5, 0.18);
        hemiLight.groundColor.setHSL(0.6, 0.3, 0.06);
        hemiLight.position.set(0, 500, 0);
        this.scene.add(hemiLight);
        return hemiLight
    }

    createNeonLight(color, x, y, z, intensity = 5, distance = 10) {
        // Disabled for bright daylight mode
        return null;
    }
}
